/**
 * Client Portal API
 * Client Portal OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ValidateLoginLinkRequest} from '../models/ValidateLoginLinkRequest';
import type {ValidateLoginLinkResponse} from '../models/ValidateLoginLinkResponse';

export interface ValidateLoginLink$Request {
    validateLoginLinkRequest: ValidateLoginLinkRequest;
}

export interface ValidateLoginLink$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateLoginLinkRequest = createAction<PayloadData<void, ValidateLoginLink$Request>>('LOGIN_LINK__VALIDATE_LOGIN_LINK__REQUEST');
export const validateLoginLinkSuccess = createAction<PayloadData<ValidateLoginLinkResponse, ValidateLoginLink$Request>>('LOGIN_LINK__VALIDATE_LOGIN_LINK__SUCCESS');
export const validateLoginLinkFailure = createAction<PayloadData<Error, ValidateLoginLink$Request, true>>('LOGIN_LINK__VALIDATE_LOGIN_LINK__FAILURE');

export const validateLoginLinkActions = [
    validateLoginLinkRequest,
    validateLoginLinkSuccess,
    validateLoginLinkFailure
] as const;

/**
 * @param {ValidateLoginLinkRequest} meta.validateLoginLinkRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateLoginLink = (meta: ValidateLoginLink$Request, config?: ValidateLoginLink$Config) => {
    return {
        CALL_API: {
            types: validateLoginLinkActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/login-links/validate`,
            TRANSPORT_REQUEST_BODY: meta.validateLoginLinkRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

